interface Props {
  children: JSX.Element;
}

export const Modal = ({ children }: Props) => {
  return (
    <div className="fixed left-0 top-0 z-50 h-full w-full bg-gray-900 bg-opacity-50">
      <div className="flex h-full w-full">{children}</div>
    </div>
  );
};
